import React, { useState } from "react";
import axios from "axios";
import { Paper, Grid, Typography, Box } from "@material-ui/core";
import EditAdNameFormatModal from "../../modals/EditAdNameFormat";
import { isAdminOrOperatorL2 } from "../../../../auth/authAdminOrOperatorL2";
import { NotificationManager } from "react-notifications";
import { formatTimeStampToLocalDateTime } from "../../../../utils";

const Basic = (props) => {
  const [nameFormat, setNameFormat] = useState(
    Boolean(props.ad.personalInfo.displayNameFormat)
      ? props.ad.personalInfo.displayNameFormat
      : null
  );
  const [showModal, setShowModal] = useState(false);

  const NameFormat = (format) => {
    switch (format) {
      case "FIRST":
        return "First name only";
      case "LAST":
        return "Last name only";
      case "FIRST_LAST":
        return "Full name";
      case "FIRST_LAST_CHAR1":
        return " First name and first letter of last name";
      case "FIRST_CHAR1_LAST":
        return " First letter of first name and full last name";
      default:
        return "-";
    }
  };

  const POST_DETAILS = [
    { label: "Member ID", value: props.ad.memberId },
    {
      label: "Created At",
      value: formatTimeStampToLocalDateTime(props.ad.createdAt),
    },
    {
      label: "First Published",
      value: formatTimeStampToLocalDateTime(props.ad.firstPublishedAt),
    },
    {
      label: "Latest Published",
      value: formatTimeStampToLocalDateTime(props.ad.publishedAt),
    },
    {
      label: "Republished Date",
      value: formatTimeStampToLocalDateTime(props.ad.republishedAt),
    },
    {
      label: "Expires At",
      value: formatTimeStampToLocalDateTime(props.ad.expiresAt),
    },
    {
      label: "Name format",
      value: NameFormat(props.ad.personalInfo.displayNameFormat),
    },
    { label: "Photos Added", value: props.ad.images.length },
    {
      label: "Exclude From Search",
      value: props.ad.excludeFromSearch ? "Yes" : "No",
    },
    {
      label: "Account Owner",
      value: props.ad.createdBy === "SELF" ? "Self" : "Parents / Family",
    },
    {
      label: "Free Boost Ads Remaining ",
      value: props.ad.remainingFreeFeaturedCount,
    },
  ];

  const PostDetailContent = ({ label, value }) => (
    <Grid container className="post-details-list-container">
      <Typography variant="body2" className="post-details-container-label">
        {label}
      </Typography>
      <Typography
        variant="body2"
        className="post-details-container-value"
        style={{ cursor: makeCursorPointer(label) }}
        onClick={() => handleEditField(label)}
      >
        {value}
      </Typography>
    </Grid>
  );

  const CloseModal = () => {
    setShowModal(false);
    setNameFormat(
      Boolean(props.ad.personalInfo.displayNameFormat)
        ? props.ad.personalInfo.displayNameFormat
        : null
    );
  };

  const HandleSave = () => {
    if (Boolean(nameFormat)) {
      const data = {
        personalInfo: {
          displayNameFormat: nameFormat,
        },
      };

      axios
        .put(
          `${process.env.REACT_APP_API_URL}/v1/admin/posts/${props.ad.id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${isAdminOrOperatorL2()}`,
              "content-type": "application/json",
            },
          }
        )
        .then((res) => {
          NotificationManager.success("Post updated", "Success");
          props.getAd();
          setShowModal(false);
        })
        .catch((err) => {
          NotificationManager.error("Post updating failed", "Error");
          setShowModal(false);
        });
    } else {
      NotificationManager.error("Empty fields!", "Error");
    }
  };

  const splitPostDetails = Math.ceil(POST_DETAILS.length / 2);
  const firstColumn = POST_DETAILS.slice(0, splitPostDetails);
  const secondColumn = POST_DETAILS.slice(splitPostDetails);

  const makeCursorPointer = (label) => {
    return (isAdminOrOperatorL2() && label === "Account Owner") ||
      label === "Name format"
      ? "pointer"
      : "";
  };

  const handleEditField = (label) => {
    if (isAdminOrOperatorL2() && label === "Account Owner") {
      props.openEditModal(
        "AccountOwner",
        "OwnerId",
        "select",
        props.ad.createdBy,
        props.accountOwnershipOptions,
        null,
        null
      );
    }
    if (label === "Name format") {
      setShowModal(true);
    }
  };

  return (
    <>
      {/* <Grid item xs={12}>
        <Paper
          elevation={0}
          className="post-details-con"
          style={{ background: "#f2f2f2" }}
        >
          <div className="row m-0">
            <div className="col p-0">
              <div className="review-col rev-col-left">
                <div className="con-row">
                  <div className="con-col">Member ID</div>
                  <div className="con-col">{props.ad.memberId}</div>
                </div>
                <div className="con-row">
                  <div className="con-col">Created At</div>
                  <div className="con-col">
                    {moment
                      .utc(props.ad.createdAt)
                      .local()
                      .format("DD-MMM-YYYY hh:mm a")}
                  </div>
                </div>
                <div className="con-row">
                  <div className="con-col">First Published</div>
                  <div className="con-col">
                    {props.ad.firstPublishedAt
                      ? moment
                          .utc(props.ad.firstPublishedAt)
                          .local()
                          .format("DD-MMM-YYYY hh:mm a")
                      : "-"}
                  </div>
                </div>
                <div className="con-row">
                  <div className="con-col">Latest Published</div>
                  <div className="con-col">
                    {props.ad.publishedAt
                      ? moment
                          .utc(props.ad.publishedAt)
                          .local()
                          .format("DD-MMM-YYYY hh:mm a")
                      : "-"}
                  </div>
                </div>
                <div className="con-row">
                  <div className="con-col">Name format</div>
                  <div className="con-col">
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowModal(true)}
                    >
                      {NameFormat(props.ad.personalInfo.displayNameFormat)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="review-col rev-col-right">
                <div className="con-row">
                  <div className="con-col">Expires At</div>
                  <div className="con-col">
                    {props.ad.expiresAt
                      ? moment
                          .utc(props.ad.expiresAt)
                          .local()
                          .format("DD-MMM-YYYY hh:mm a")
                      : "-"}
                  </div>
                </div>
                <div className="con-row">
                  <div className="con-col">Free Renew</div>
                  <div className="con-col">
                    {props.ad.freeRenewDone ? "Done" : "Not yet"}
                  </div>
                </div>
                <div className="con-row">
                  <div className="con-col">Photos Added</div>
                  <div className="con-col">{props.ad.images.length}</div>
                </div>
                <div className="con-row">
                  <div className="con-col">Exclude From Search</div>
                  <div className="con-col">
                    {props.ad.excludeFromSearch ? "Yes" : "No"}
                  </div>
                </div>
                <div className="con-row">
                  <div className="con-col">Account Owner</div>
                  <div
                    className="con-col"
                    style={isAdminOrOperatorL2() ? { cursor: "pointer" } : {}}
                    onClick={
                      isAdminOrOperatorL2()
                        ? (e) => {
                            props.openEditModal(
                              "AccountOwner",
                              "OwnerId",
                              "select",
                              props.ad.createdBy,
                              props.accountOwnershipOptions,
                              null,
                              null
                            );
                          }
                        : null
                    }
                  >
                    {props.ad.createdBy === "SELF"
                      ? "Self"
                      : "Parents / Family"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </Grid> */}

      <Paper
        elevation={0}
        className="post-details-con flex justify-between gap-x-16"
      >
        <Box className="flex-1">
          {firstColumn.map(({ label, value }) => {
            return <PostDetailContent label={label} value={value} />;
          })}
        </Box>
        <Box className="flex-1">
          {secondColumn.map(({ label, value }) => {
            return <PostDetailContent label={label} value={value} />;
          })}
        </Box>
      </Paper>

      <EditAdNameFormatModal
        showModal={showModal}
        nameFormat={nameFormat}
        updateNameFormat={setNameFormat}
        handleClose={CloseModal}
        handleSave={HandleSave}
      />
    </>
  );
};

export default Basic;
